<div class="mb-4 p-3 surface-100 border-round">
    <div class="font-bold mb-3 text-primary text-sm">Instructions:</div>
    <ol class="pl-4 m-0 line-height-3 text-sm">
        <li>Select the column name(s) from the dropdown list below and download the template</li>
        <li class="text-orange-600 font-semibold">Note: DO NOT MODIFY HEADER NAMES</li>
        <li class="text-orange-600 font-semibold">Note: DO NOT MODIFY TMEIC MVPS #</li>
        <li>Modify the data as required</li>
        <li>Upload the modified excel sheet and click on "Upload and Save" button to verify the data</li>
        <li>Click on "Save" button on main screen to update</li>
    </ol>
</div>

<p-card class="mb-3">
    <div class="font-bold mb-2">Download Bulk Update Template</div>
    <div class="font-small col-12">
        Select the data fields you want to include in the bulk update template:
    </div>
    <div class="col-12">
        <p-multiSelect [options]="dataFields" [ngModel]="selectedItems" (onChange)="onSelectionChange($event)" appendTo="body" optionLabel="title"
            placeholder="Select Data Fields" class="w-full"></p-multiSelect>
    </div>
    <div class="col-12">
        <p-button [disabled]="dataFields.length ==0" (click)="downloadTemplate()" label="Download Template"
            icon="pi pi-download">
        </p-button>
    </div>
</p-card>
<p-card>
    <div class="font-bold mb-2">Upload Updated Excel Sheet</div>
    <div class="col-12">
        Select the updated excel sheet to import the data:
    </div>
    <div class="col-12">
        <p-fileUpload #fileInput name="blockScheduleBulkUpdateFile" accept=".xlsx" mode="basic"
            chooseLabel="Choose File" (onSelect)="onFileSelect($event)" (onClear)="onFileClear()"
            [customUpload]="true" [auto]="false" maxFileSize="10485760">
        </p-fileUpload>
        <div *ngIf="fileSelected" class="mt-2 text-sm">
            Selected file: {{ fileSelected.name }}
        </div>
    </div>
</p-card>
 <div class="flex justify-content-end gap-3 pt-4 mt-4 border-top-1 surface-border">
    <p-button [disabled]="!fileSelected" (click)="onFileUpload()" label="Upload and Save" icon="pi pi-upload">
    </p-button>
    <p-button (click)="cancel()" severity="secondary" label="Cancel" icon="pi pi-times" class="ml-2">
    </p-button>
</div>
